import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import "./style.scss";
import uris from "../../../config/uris";
import Breadcrumbs from "../../../assets/component/breadcrumbs";
import PlaybookMain, { fetchStoredTabs } from "../../esg-chat/playbooks";
import CustomTab from "../../../assets/component/tab";

const tabOptions = {
    key: 1,
    title: 'Screening',
    value: 'screening',
    tabs: [
        // {
        //     key: 1.1,
        //     title: 'USCCB',
        //     payloadType: "USCCB",
        // },
        {
            key: 1.1,
            title: 'MID',
            payloadType: "MID",
        },
        {
            key: 1.2,
            title: 'DDQ for Private Eq',
            payloadType: "DDQ for Private Eq",
        },
        {
            key: 1.3,
            title: 'Bank H - Screen',
            payloadType: "Bank H - Screen",
        },
        {
            key: 1.4,
            title: 'Asset Manager H',
            payloadType: "Asset Manager H",
        },
        {
            key: 1.5,
            title: 'Bank SG',
            payloadType: "Bank SG",
        },
        {
            key: 1.6,
            title: 'Bank Screening',
            payloadType: "Bank Screening",
        },
        {
            key: 1.7,
            title: 'Sustainable Procurement',
            payloadType: "Sustainable Procurement",
        },
        {
            key: 1.8,
            title: 'LkSG German Supply Chain Act',  
            payloadType: "LkSG German Supply Chain Act",
        }
        // {
        //     key: 1.6,
        //     title: 'UNPRI',
        //     payloadType: "UNPRI",
        // },
        // {
        //     key: 1.7,
        //     title: 'UNPRI DDQ',
        //     payloadType: "UNPRI DDQ",
        // },
    ]
}

const Screeners = () => {
    const [questionInput, setQuestionInput] = useState("");
    const [presetQuestion, setPresetQuestion] = useState("");
    const [playbookDetails, setPlaybookDetails] = useState({})
    const [activeTab, setActiveTab] = useState("");

    const navigate = useNavigate();

    useEffect(() => {
        const storedTabs = fetchStoredTabs({ playbookName: tabOptions?.title })

        if (storedTabs) {
            const filteredTabOptions = {
                ...tabOptions,
                tabs: tabOptions.tabs.filter(tab => storedTabs?.includes(tab.title))
            };

            setPlaybookDetails(filteredTabOptions)
            setActiveTab(filteredTabOptions?.tabs[0]?.payloadType)
        } else {
            setPlaybookDetails(tabOptions)
            setActiveTab(tabOptions?.tabs[0]?.payloadType)
        }
    }, [setPlaybookDetails, setActiveTab])

    useEffect(() => {
        if (questionInput) {
            navigate(uris.companyResearch, { state: { question: questionInput, presetQuestion: presetQuestion } });
        }
    }, [presetQuestion, questionInput])

    return (
        <div className="screeners-playbook-container">
            <Breadcrumbs />
            <CustomTab tabOptions={playbookDetails} setTabValue={setActiveTab} tabValue={activeTab}>
                {activeTab && (
                    <div className="playbook-contents">
                        <PlaybookMain
                            promptType={activeTab}
                            setQuestionInput={setQuestionInput}
                            setPresetQuestion={setPresetQuestion}
                        />
                    </div>
                )}
            </CustomTab>
        </div>
    )
}

export default Screeners;